import { xcoverAPI } from '@whitelabel/xcover-shared/store/services/xcover/index';
import { processKeys } from '@whitelabel/xcover-shared/helpers/api';
import { IPage } from '@whitelabel/helpers/types';
import { getAPIHost } from '@whitelabel/xcover-shared/helpers/multiRegion';

export interface IGetPages {
  slug: string;
  locale: string;
  revisionId?: string | null;
  partner?: string | null;
}

export interface IGetDisclaimer {
  slug: string;
  locale: string;
}

export const pageAPI = xcoverAPI.injectEndpoints({
  endpoints: (builder) => ({
    getPage: builder.query<IPage, IGetPages>({
      query: ({ locale, slug, partner, revisionId }) => {
        const searchParams = new URLSearchParams({
          language: locale,
          ...(partner && { partner }),
          ...(revisionId && { revision_id: revisionId }),
        });

        const url = `${getAPIHost()}/staticpages/${slug}/?${searchParams}`;
        return url;
      },
      transformResponse: (response: IPage) => processKeys(response),
      keepUnusedDataFor: 900,
    }),

    getDisclaimer: builder.query<IPage, IGetDisclaimer>({
      query: ({ slug, locale }) => {
        const searchParams = new URLSearchParams({ language: locale });

        const url = `${getAPIHost()}/staticpages/${slug}/?${searchParams}`;

        return url;
      },

      transformResponse: (response: IPage) => processKeys(response),
      keepUnusedDataFor: 900,
    }),
  }),
});

export const { useGetPageQuery, useGetDisclaimerQuery } = pageAPI;
